import { useLoaderData, useNavigate } from "@remix-run/react";
import lodash from "lodash";
import { useTranslation } from "react-i18next";
import Accordion from "~/components/Accordion";
import Container from "~/components/Container";
import ProductActionBar from "~/components/ProductActionBar";
import Products from "~/components/Products";
import contents from "~/constants/contents";

function ServicesMobile({
  textQuery,
  setTextQuery,
  sortFilter,
  setSortFilter,
  productsMappedWithProviders,
}) {
  const { cookie, user, params, service } = useLoaderData();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const { t, i18n } = useTranslation();

  const renderFaq = () => {
    if (!lodash.isEmpty(service.content.faq)) {
      return service.content?.faq.map((f) => (
        <Accordion key={f.q} title={f.q} description={f.a} />
      ));
    }

    return contents?.faq.map((f) => (
      <Accordion key={f.q} title={t(f.q)} description={t(f.a)} />
    ));
  };

  return (
    <section className="py-28 bg-base-200">
      <Container className="rounded-2xl p-12 px-12 grid grid-cols-1 md:grid-cols-5 gap-20 bg-white max-w-7xl">
        <div className="md:col-span-2">
          <ProductActionBar
            service={service}
            goBack={goBack}
            textQuery={textQuery}
            setTextQuery={setTextQuery}
            sortFilter={sortFilter}
            setSortFilter={setSortFilter}
            i18n={i18n}
            t={t}
          />
          <div className="border-b border-base-200/70 mt-4" />

          <div className="my-4 flex flex-col gap-2">
            {productsMappedWithProviders.map((p) => {
              return (
                <section className="flex flex-col gap-1">
                  <h2 className="text-xs font-semibold text-zinc-500 px-5 uppercase">
                    {t(`providers.${p.provider.name.common}`)}
                  </h2>
                  <div className="rounded-2xl overflow-hidden w-full">
                    <Products
                      products={p.products}
                      params={params}
                      cookie={cookie}
                      user={user}
                    />
                  </div>
                </section>
              );
            })}
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="flex flex-col gap-8">
            <h1 className="text-neutral-900 text-[40px] font-bold font-['Hubot-Sans','IRANYekanXVF'] leading-[64px]">
              {service.content?.title ||
                t("buyVirtualNumbersFor", {
                  name: lodash.capitalize(service.name.common),
                })}
            </h1>
            {service.media?.feature && (
              <img
                src={`${service.media.feature}?format=webp&with=1000&height=500`}
                alt={service.name.common}
                className="rounded-2xl w-full object-cover"
              />
            )}
            <h2
              className="text-neutral-900 text-base font-normal font-['Figtree', 'IRANYekanXVF'] leading-7"
              dangerouslySetInnerHTML={{
                __html: service.content.description || t("home.description"),
              }}
            />

            <div className="justify-start items-start gap-5 grid grid-cols-2 border-b border-base-200/70 pb-8">
              {contents.benefits.map((b) => {
                if (
                  i18n.language !== "fa" &&
                  b.name === "home.benefits.visaAndCreditCardAccepted"
                )
                  return null;
                return (
                  <div className="p-5 bg-[#e0f7e8] rounded-lg flex-col justify-start items-center gap-5 flex">
                    <div className="p-3 bg-[#c2efd1] rounded-full justify-center items-center gap-2 flex">
                      <b.Icon />
                    </div>
                    <div className="text-center text-neutral-900 text-base font-semibold font-['Hubot-Sans', 'IRANYekanXVF'] leading-normal">
                      {t(b.name)}
                    </div>
                  </div>
                );
              })}
            </div>

            <div>
              <h2 className="text-neutral-900 text-[40px] uppercase font-bold font-['Hubot-Sans', 'IRANYekanXVF'] leading-[64px]">
                {t("faq")}
              </h2>

              <div className="flex gap-6 mt-5">
                <div className="z-10 flex flex-col w-full justify-center gap-3">
                  {renderFaq()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default ServicesMobile;
